var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{class:("font-weight-bold text-h4 text-center mb-5 " + (_vm.getPreferences.secondaryColor) + "--text")},[_vm._v(" Registrate ")]),_c('SignUp')],1)}
var staticRenderFns = []

export { render, staticRenderFns }